import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WeaponsRoutingModule } from './weapons-routing.module';
import { RootAccountComponent } from './root-account/root-account.component';
import { MyWeaponsComponent } from './my-weapons/my-weapons.component';
import { SharedProfileModule } from './shared/shared-profile.module';
import { NewWeaponComponent } from './new-weapon/new-weapon.component';
import { UpdateWeaponComponent } from './update-weapon/update-weapon.component';
import { MyRequestsComponent } from './my-requests/my-requests.component';
import { NewRequestComponent } from './new-request/new-request.component';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';

@NgModule({
  declarations: [
    RootAccountComponent,
    MyWeaponsComponent,
    NewWeaponComponent,
    UpdateWeaponComponent,
    MyRequestsComponent,
    NewRequestComponent,
    DisclaimerComponent,
  ],
  imports: [CommonModule, WeaponsRoutingModule, SharedProfileModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class WeaponsModule {}
